import styled from "styled-components";

export const StyledDiv = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  padding: 1%;
  width: 92%;
`;
